import { Badge, Button, Popover, Select, Text, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react'
import { AiOutlineDelete } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { destroyRequester, fetchRequester } from '../../../redux/actions/requeterAction';
import { DataTable } from 'mantine-datatable';
import { fetchComplaintsById } from '../../../redux/actions/complaintsActions';
import { MonthPickerInput } from '@mantine/dates';
import { fetchRegion } from '../../../redux/actions/regionAction';
import { fetchCounterByPrinter } from '../../../redux/actions/counterLogsAction';

const CounterLogsListTable = ({ id, PAGE_SIZE = 30 }) => {
    const [data, setProductData] = useState([]);
    const [dataOfTable, setDataOfTable] = useState(data || []);
    const [page, setPage] = useState(1);
    const { loading, counterLogsList } = useSelector((state) => state?.counterLog);
    const { regionList } = useSelector((state) => state?.region);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [value, setValue] = useState(new Date());
    const [regionValue, setRegionValue] = useState(2)
    const [regions, setRegions] = useState([])

    const [records, setRecords] = useState(dataOfTable?.slice(0, PAGE_SIZE) || []);
    const [query, setQuery] = useState('');
    const [statusQuery, setStatusQuery] = useState('');

    useEffect(() => {
        const names = regionList.map((item) => ({ value: item.id, label: item.name }));
        setRegions(names);
    }, [regionList]);

    useEffect(() => {
        setDataOfTable(
            data?.filter(({ customer, status }) => {
                const customerMatch = customer?.toLowerCase()?.includes(query?.trim()?.toLowerCase());
                const statusMatch = status?.toLowerCase()?.includes(statusQuery?.trim()?.toLowerCase());
                return customerMatch && statusMatch;
            })
        );
    }, [query, statusQuery]);


    useEffect(() => {
        dispatch(fetchRegion());
    }, []);


    useEffect(() => {
        setDataOfTable(data);
    }, [data]);



    useEffect(() => {
        dispatch(fetchCounterByPrinter(id, formatDateToMMYYYY(value)));
    }, [id, value]);

    useEffect(() => {
        setProductData(counterLogsList)
    }, [counterLogsList]);

    useEffect(() => {
        const from = (page - 1) * PAGE_SIZE;
        const to = from + PAGE_SIZE;
        setRecords(dataOfTable?.slice(from, to));
    }, [page, dataOfTable]);


    const product_columns = [

        {
            accessor: "id",
            width: "auto",
            title: "Token",
        },
        {
            accessor: "customer",
            width: "auto",
            title: "CUSTOMERS",
            filter: (
                <TextInput
                    label="Customer"
                    placeholder="Customer emails..."
                    icon={<IconSearch size={16} />}
                    value={query}
                    clearable
                    onChange={(e) => setQuery(e.currentTarget.value)}
                />
            ),

        },
        {
            accessor: "location",
            width: "auto",
            title: "LOCATIONS",
        },
        {
            accessor: "complaint_problem",
            width: "auto",
            title: "COMPLAINTS PROBLEM",

        },

        {
            accessor: "log_type",
            width: "auto",
            title: "Log Type",
            render: (records) => <Badge variant='filled' color={records.log_type == 'counter' ? 'red' : records.log_type == 'complaint' ? 'blue' : 'green'}>{records.log_type}</Badge>,


        },
        {
            accessor: "counter",
            width: "auto",
            title: "Counter",
        },


        {
            accessor: "user",
            width: "auto",
            title: "USER",
            render: (records) => (records.user.name),
        },


    ];




    return (
        <div>
            <div className="d-flex mb-3 justify-content-between align-items-end">
                <h3 className="m-0" onClick={() => dispatch(fetchCounterByPrinter(id, formatDateToMMYYYY(value)))}>Counter Logs List</h3>
                <div className="d-flex gap-3 align-items-end">
                    <div>
                        <Text>
                            Total this Month :
                            {counterLogsList?.length > 0 && parseInt(counterLogsList[0]?.counter - counterLogsList[counterLogsList?.length - 1]?.counter)}
                        </Text>
                    </div>

                    <MonthPickerInput
                        label="Complaint Month"
                        valueFormat="MMM YYYY"
                        defaultValue={new Date()}
                        value={value}
                        variant='filled'
                        onChange={setValue}
                    />
                </div>
            </div>
            <DataTable
                className="data-table-with-actions"
                withBorder
                records={records}
                withColumnBorders
                striped
                highlightOnHover
                verticalSpacing={10}
                columns={
                    product_columns
                }
                totalRecords={dataOfTable?.length}
                recordsPerPage={PAGE_SIZE}
                page={page}
                onPageChange={(p) => setPage(p)}
                fetching={loading}
                minHeight={400}
                loaderVariant="dots"
                noRecordsText="No records found"
                paginationText={({ from, to, totalRecords }) =>
                    `Records ${from} - ${to} of ${totalRecords}`
                }
                paginationSize="md"
            />
        </div >
    )
}
function formatDateToMMYYYY(inputDate) {
    const date = new Date(inputDate);

    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Get the month (1-indexed)
    const year = date.getFullYear(); // Get the full year

    return `${month}-${year}`;
}
export default CounterLogsListTable